<div class="wrapper">
    <app-humi-logo size="medium" labelOrientation="horizontal"></app-humi-logo>
    <h1>{{ 'forbidden' | appTranslate }}</h1>
    <p>{{ 'noPermission' | appTranslate }}</p>
    <ui-button type="primary" [url]="'/'">{{ 'returnHome' | appTranslate }}</ui-button>
</div>
